import { FeatureFlags } from 'src/api/types/featureFlags';
import { RootState } from 'src/store';
import { useAppSelector } from 'src/store/hooks';

export const useHasFeatureFlag = (flag: keyof FeatureFlags): boolean => {
  const featureFlags = useFeatureFlags();

  if (!featureFlags) {
    return false;
  }

  const flagValue = featureFlags[flag];

  if (flagValue === undefined) {
    // Don't warn if feature flags are still loading
    return false;
  }

  return flagValue;
};

export const useHasFeatureFlags = (flags: (keyof FeatureFlags)[]): boolean => {
  const featureFlags = useFeatureFlags();
  if (!featureFlags) {
    return false;
  }

  const allFlagsEnabled = flags.every((flag) => {
    const flagValue = featureFlags[flag];
    if (flagValue === undefined) {
      // Don't warn if feature flags are still loading
      return false;
    }
    return flagValue;
  });
  return allFlagsEnabled;
};

export const useHasAnyFeatureFlag = (flags: (keyof FeatureFlags)[]): boolean => {
  const featureFlags = useFeatureFlags();
  if (!featureFlags) {
    return false;
  }
  return flags.some((flag) => featureFlags[flag]);
};

export const useFeatureFlags = (): FeatureFlags | undefined => {
  const featureFlags = useAppSelector((state: RootState) => state.auth.featureFlags);

  return featureFlags;
};
